const required = 'This is a required field.';
const email = 'This needs to be an email.';

export { required, email };
